import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
import {
  getTasksData,
  getTaskByProject,
} from "../../services/service.js";
import "../../assets/css/doctor.scss";
import "../../assets/css/pharmacy.scss";

import ListHeader from "../../molecules/ListHeader/ListHeader.js";
import DG from "../../atoms/DataTable/DataGrid.js";
import CustomPagination from "../../atoms/CustomPagination/index.jsx";
import CreateTaskSidebar from "../../components/common/CreateTaskSideBar.js";
import DataGridSkeleton from "../../atoms/DataTable/DataGridSkeleton.js";

const ViewTasks = () => {
  const [loader, setLoader] = useState(true);
  const [totalTasks, setTotalTasks] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [tasksData, setTasksData] = useState([]);
  const [isSidebarVisible, setSidebarVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);

  const itemsPerPage = 10;

  const handleOpenSidebar = (task = null) => {
    setSidebarVisible(true);
  };
  const handleOpenSidebarUpdate = (task = null) => {
    setSelectedTask(task);
    setSidebarVisible(true);
  };
  
  const handleCloseSidebar = () => {
    setSelectedTask(null);
    setSidebarVisible(false);
    // handleGetData();
  };

  const handleGetData = async () => {
    setLoader(true);
    try {
      const response = await getTasksData(
        currentPage,
        itemsPerPage,
        selectedProjectId,
        searchQuery
      );
      
      if (response?.success) {
        setTasksData(response?.data || []);
        setTotalTasks(response?.pagination?.totalItems || 0);
      } else {
        setTasksData([]);
        setTotalTasks(0);
      }
    } catch (error) {
      console.error("Error fetching tasks data:", error);
      setTasksData([]);
      setTotalTasks(0);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    const debounceTimer = setTimeout(() => {
      handleGetData();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [selectedProjectId, currentPage, searchQuery]);

  const handleSearchChange = (data) => {
    const projectId = typeof data === 'object' ? data.project_id : data;
    setSelectedProjectId(projectId || null);
    setCurrentPage(1);
  };

  const handleTaskSearchChange = (value) => {
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="w-full flex flex-col gap-4">
        <div className="w-full">
          <ListHeader
            mainHeading="Task Management"
            placeholder="Search Tasks"
            btnShow={true}
            linkBreadCrum="/view-project"
            blinkBreadCrumText="Task Management"
            blinkBreadCrumText1="View Tasks"
            searchShow={true}
            showLikeFilter={false}
            DropDown={false}
            handleSearchChange={handleSearchChange}
            handleProjectSearchChange={handleTaskSearchChange}
            searchValue={searchQuery}
            moduleType="tasks"
            showProjectFilter={true}
          />
          <div className="flex justify-end px-2 mt-2">
            <button
              onClick={() => handleOpenSidebar()}
              className="w-[140px] py-1 rounded-[4px] bg-[#F97316] font-medium text-base text-white"
            >
              Create Task
            </button>
          </div>
        </div>

        <div className="w-full px-2 pt-3">
          {loader ? (
            <DataGridSkeleton
              totalRow={10}
              totalCol={10}
              image={false}
            />
          ) : (
            <DG 
              index={6} 
              loader={loader} 
              data={tasksData}
              handleEdit={handleOpenSidebarUpdate}
              getData={handleGetData}
            />
          )}
        </div>
        {totalTasks > 0 && (
          <CustomPagination
            totalItems={totalTasks}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        )}
      </div>
      <CreateTaskSidebar
        visible={isSidebarVisible}
        onClose={handleCloseSidebar}
        from='taskList'
        taskData={selectedTask}
        projectId={selectedTask?.project_id}
        onSuccess={handleGetData}
      />
    </>
  );
};

export default ViewTasks;
